import Icon from '@/components/common/iconedLinks/Icon';

type CallToActionLabelProps = {
  label?: string | React.ReactNode,
  icon: {
    url: string
    alt?: string,
    width?: number,
    height?: number,
    className?: string
  };
  className?: string,
  style?: object,
}

export const CallToActionLabel = ({ label, icon, className, style } : CallToActionLabelProps): React.JSX.Element => (
  <>
    {icon && (
      <Icon
        src={icon.url}
        alt={icon.alt}
        width={icon.width || 24}
        height={icon.height || 24}
        data-test-id="icon"
        className={icon.className}
      />
    )}
    {label && <span className={className} style={style} data-test-id="label">{label}</span>}
  </>
);

export default CallToActionLabel;
